import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", imgClass = "h-8", to = "/" }) {
  return (
    <Link to={to} data-testid="vorna-logo" className={`inline-flex items-center leading-none ${className}`}>
      <img src="/logo.png" alt="VORNA" className={`w-auto ${imgClass}`} />
    </Link>
  );
}
